/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  Cafe24PayByOrderIdParams,
  Cafe24RefundByOrderIdParams,
  CommonResponseDto,
  DeletePaymentMethodParams,
  HTTPValidationError,
  PayByAccountIdParams,
  PaymentHistoryResponseDto,
  TossAuthorizationRequest,
  UpdateDefaultMethodRequestDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 기본결제수단변경API
 * @summary UpdateDefaultMethod
 */
export const updateDefaultMethod = (
    updateDefaultMethodRequestDto: UpdateDefaultMethodRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/payment/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDefaultMethodRequestDto
    },
      options);
    }
  


export const getUpdateDefaultMethodMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefaultMethod>>, TError,{data: UpdateDefaultMethodRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDefaultMethod>>, TError,{data: UpdateDefaultMethodRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDefaultMethod>>, {data: UpdateDefaultMethodRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateDefaultMethod(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDefaultMethodMutationResult = NonNullable<Awaited<ReturnType<typeof updateDefaultMethod>>>
    export type UpdateDefaultMethodMutationBody = UpdateDefaultMethodRequestDto
    export type UpdateDefaultMethodMutationError = HTTPValidationError

    /**
 * @summary UpdateDefaultMethod
 */
export const useUpdateDefaultMethod = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDefaultMethod>>, TError,{data: UpdateDefaultMethodRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateDefaultMethod>>,
        TError,
        {data: UpdateDefaultMethodRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateDefaultMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 결제수단등록API
 * @summary RegisterPaymentMethod
 */
export const registerPaymentMethod = (
    tossAuthorizationRequest: TossAuthorizationRequest,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/payment/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tossAuthorizationRequest
    },
      options);
    }
  


export const getRegisterPaymentMethodMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPaymentMethod>>, TError,{data: TossAuthorizationRequest}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof registerPaymentMethod>>, TError,{data: TossAuthorizationRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerPaymentMethod>>, {data: TossAuthorizationRequest}> = (props) => {
          const {data} = props ?? {};

          return  registerPaymentMethod(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof registerPaymentMethod>>>
    export type RegisterPaymentMethodMutationBody = TossAuthorizationRequest
    export type RegisterPaymentMethodMutationError = HTTPValidationError

    /**
 * @summary RegisterPaymentMethod
 */
export const useRegisterPaymentMethod = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerPaymentMethod>>, TError,{data: TossAuthorizationRequest}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof registerPaymentMethod>>,
        TError,
        {data: TossAuthorizationRequest},
        TContext
      > => {

      const mutationOptions = getRegisterPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 결제수단삭제API
 * @summary DeletePaymentMethod
 */
export const deletePaymentMethod = (
    params: DeletePaymentMethodParams,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/payment/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeletePaymentMethodMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{params: DeletePaymentMethodParams}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{params: DeletePaymentMethodParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePaymentMethod>>, {params: DeletePaymentMethodParams}> = (props) => {
          const {params} = props ?? {};

          return  deletePaymentMethod(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof deletePaymentMethod>>>
    
    export type DeletePaymentMethodMutationError = HTTPValidationError

    /**
 * @summary DeletePaymentMethod
 */
export const useDeletePaymentMethod = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePaymentMethod>>, TError,{params: DeletePaymentMethodParams}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deletePaymentMethod>>,
        TError,
        {params: DeletePaymentMethodParams},
        TContext
      > => {

      const mutationOptions = getDeletePaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 결제내역을가져오는API
 * @summary GetPaymentHistories
 */
export const getPaymentHistories = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<PaymentHistoryResponseDto>(
      {url: `/payment/histories`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPaymentHistoriesQueryKey = () => {
    return [`/payment/histories`] as const;
    }

    
export const getGetPaymentHistoriesQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentHistoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentHistories>>> = ({ signal }) => getPaymentHistories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentHistoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentHistories>>>
export type GetPaymentHistoriesQueryError = HTTPValidationError


export function useGetPaymentHistories<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentHistories>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetPaymentHistories<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentHistories>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetPaymentHistories<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetPaymentHistories
 */

export function useGetPaymentHistories<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPaymentHistoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPaymentHistoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentHistoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentHistories>>> = ({ signal }) => getPaymentHistories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentHistoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentHistories>>>
export type GetPaymentHistoriesSuspenseQueryError = HTTPValidationError


export function useGetPaymentHistoriesSuspense<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetPaymentHistoriesSuspense<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetPaymentHistoriesSuspense<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetPaymentHistories
 */

export function useGetPaymentHistoriesSuspense<TData = Awaited<ReturnType<typeof getPaymentHistories>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaymentHistories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPaymentHistoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Parameter의계정ID결재실행API
 * @summary PayByAccountId
 */
export const payByAccountId = (
    params: PayByAccountIdParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/payment/pay`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPayByAccountIdQueryKey = (params: PayByAccountIdParams,) => {
    return [`/payment/pay`, ...(params ? [params]: [])] as const;
    }

    
export const getPayByAccountIdQueryOptions = <TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(params: PayByAccountIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPayByAccountIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof payByAccountId>>> = ({ signal }) => payByAccountId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData> & { queryKey: QueryKey }
}

export type PayByAccountIdQueryResult = NonNullable<Awaited<ReturnType<typeof payByAccountId>>>
export type PayByAccountIdQueryError = HTTPValidationError


export function usePayByAccountId<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof payByAccountId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function usePayByAccountId<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof payByAccountId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function usePayByAccountId<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary PayByAccountId
 */

export function usePayByAccountId<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPayByAccountIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPayByAccountIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(params: PayByAccountIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPayByAccountIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof payByAccountId>>> = ({ signal }) => payByAccountId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData> & { queryKey: QueryKey }
}

export type PayByAccountIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof payByAccountId>>>
export type PayByAccountIdSuspenseQueryError = HTTPValidationError


export function usePayByAccountIdSuspense<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function usePayByAccountIdSuspense<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function usePayByAccountIdSuspense<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary PayByAccountId
 */

export function usePayByAccountIdSuspense<TData = Awaited<ReturnType<typeof payByAccountId>>, TError = HTTPValidationError>(
 params: PayByAccountIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof payByAccountId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPayByAccountIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24환불API
 * @summary Cafe24RefundByOrderId
 */
export const cafe24RefundByOrderId = (
    params: Cafe24RefundByOrderIdParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/payment/cafe24-refund`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCafe24RefundByOrderIdQueryKey = (params: Cafe24RefundByOrderIdParams,) => {
    return [`/payment/cafe24-refund`, ...(params ? [params]: [])] as const;
    }

    
export const getCafe24RefundByOrderIdQueryOptions = <TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCafe24RefundByOrderIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cafe24RefundByOrderId>>> = ({ signal }) => cafe24RefundByOrderId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData> & { queryKey: QueryKey }
}

export type Cafe24RefundByOrderIdQueryResult = NonNullable<Awaited<ReturnType<typeof cafe24RefundByOrderId>>>
export type Cafe24RefundByOrderIdQueryError = HTTPValidationError


export function useCafe24RefundByOrderId<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cafe24RefundByOrderId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24RefundByOrderId<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cafe24RefundByOrderId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24RefundByOrderId<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary Cafe24RefundByOrderId
 */

export function useCafe24RefundByOrderId<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCafe24RefundByOrderIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCafe24RefundByOrderIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCafe24RefundByOrderIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cafe24RefundByOrderId>>> = ({ signal }) => cafe24RefundByOrderId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData> & { queryKey: QueryKey }
}

export type Cafe24RefundByOrderIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof cafe24RefundByOrderId>>>
export type Cafe24RefundByOrderIdSuspenseQueryError = HTTPValidationError


export function useCafe24RefundByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24RefundByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24RefundByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary Cafe24RefundByOrderId
 */

export function useCafe24RefundByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24RefundByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24RefundByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCafe24RefundByOrderIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 카페24결제실패시카페24만따로결제하기위한API
 * @summary Cafe24PayByOrderId
 */
export const cafe24PayByOrderId = (
    params: Cafe24PayByOrderIdParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<CommonResponseDto>(
      {url: `/payment/cafe24-payment`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCafe24PayByOrderIdQueryKey = (params: Cafe24PayByOrderIdParams,) => {
    return [`/payment/cafe24-payment`, ...(params ? [params]: [])] as const;
    }

    
export const getCafe24PayByOrderIdQueryOptions = <TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCafe24PayByOrderIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cafe24PayByOrderId>>> = ({ signal }) => cafe24PayByOrderId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData> & { queryKey: QueryKey }
}

export type Cafe24PayByOrderIdQueryResult = NonNullable<Awaited<ReturnType<typeof cafe24PayByOrderId>>>
export type Cafe24PayByOrderIdQueryError = HTTPValidationError


export function useCafe24PayByOrderId<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cafe24PayByOrderId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24PayByOrderId<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cafe24PayByOrderId>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24PayByOrderId<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary Cafe24PayByOrderId
 */

export function useCafe24PayByOrderId<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCafe24PayByOrderIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCafe24PayByOrderIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCafe24PayByOrderIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cafe24PayByOrderId>>> = ({ signal }) => cafe24PayByOrderId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData> & { queryKey: QueryKey }
}

export type Cafe24PayByOrderIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof cafe24PayByOrderId>>>
export type Cafe24PayByOrderIdSuspenseQueryError = HTTPValidationError


export function useCafe24PayByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24PayByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useCafe24PayByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary Cafe24PayByOrderId
 */

export function useCafe24PayByOrderIdSuspense<TData = Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError = HTTPValidationError>(
 params: Cafe24PayByOrderIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof cafe24PayByOrderId>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCafe24PayByOrderIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



